import Product from '@/api/product.js'

let cachedCategories = null
let fetchPromise = null

export function getCategories () {
  if (cachedCategories) {
    return Promise.resolve(cachedCategories)
  }
  if (fetchPromise) {
    return fetchPromise
  }
  fetchPromise = new Promise(async (resolve, reject) => {
    try {
      const params = { page: null, pageSize: null, startStatus: 1 }
      const { code, data } = await Product.productCategoryList(params)
      if (code === 200) {
        cachedCategories = data.filter(item => item.startStatus === 1)
        resolve(cachedCategories)
      } else {
        reject(new Error('获取分类失败'))
      }
    } catch (error) {
      reject(error)
    } finally {
      fetchPromise = null
    }
  })
  return fetchPromise
}



// WEBPACK FOOTER //
// ./src/utils/categoryStore.js